import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {getTeamLogo} from '../utils';

import styles from './bracket-match-team.module.css';

const BracketMatchTeam = ({team, winner, loser}) => {

  const wrapperClassnames = clsx({
    [styles.teamWrapper]: true,
    [styles.winner]: winner,
    [styles.loser]: loser
  });

  const scoreClassnames = clsx({
    [styles.teamScore]: true,
    [styles.winnerScore]: winner
  });

  const logoClassnames = clsx({
    [styles.teamLogo]: true,
    [styles.teamLogoLoser]: loser
  });

  return (
    <div className={wrapperClassnames}>
      {team
        ? (
          <>
            <img src={getTeamLogo(team?.id)} alt={team?.name} className={logoClassnames} />
            <p className={styles.teamName}>{team?.name}</p>
            {!isNaN(team.score) && <span className={scoreClassnames}>{team?.score}</span>}
          </>
        )
        : <p className={styles.emptyTeam}>Команда не определена</p>
      }
    </div>
  );
};

BracketMatchTeam.propTypes = {
  team: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    score: PropTypes.number
  }),
  winner: PropTypes.bool,
  loser: PropTypes.bool
};

BracketMatchTeam.defaultProps = {
  team: null,
  winner: false,
  loser: false
};

export default BracketMatchTeam;
